import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ArtikelDetailComponent } from '../../pages/artikel-detail/artikel-detail.component';

// Registered eagerly on SOFTLINE_CONFIG_ARTIKEL_INFO_MODAL_COMPONENT; @defer keeps
// the heavy detail page out of the boot-time globals closure.
@Component({
  selector: 'soft-lazy-artikel-detail',
  imports: [ArtikelDetailComponent],
  template: `
    @defer {
      @if (id() !== undefined) {
        <soft-artikel-detail [id]="id()!" [params]="params()" />
      } @else {
        <soft-artikel-detail />
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyArtikelDetailComponent {
  readonly id = input<number>();
  readonly params = input<
    | {
        vkforgRestriction: boolean;
        showUmsatzabfrage: boolean;
        showEslFlash: boolean;
      }
    | undefined
  >(undefined);
}
